import styled from 'styled-components';
const ResultListStyled = styled.div`
  flex-grow: 1;
  /* padding: 0 12px; */
  .date-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .handle_btn {
    justify-content: center;
    display: flex;

    > div {
      margin-right: 15px;
    }
    span {
      font-size: 16px;
      color: #fff;
    }
    img {
      width: 18px;
      height: 18px;
    }
  }
  .url-point-style {
    cursor: pointer;
    position: relative;
    color: ${(props) => props.theme.palette.primary.main};
    display: block;
    transform: scale(1, 1);
    transition: all 0.3s;
  }
  .url-point-style:hover {
    transform: scale(1.1, 1.1);
    transition: all 0.3s;
  }
`;
export default ResultListStyled;
